<template>
<div>
 <h1>About Beagles</h1>
 <div class="section">
 <div class="columns">
  <div class="column">
    <div class="card tb-padding">
            <div class="title">Beagles</div>
        <div class="card-content">
            <ul>
                <li>
                    <a href="http://">Sponsorship</a>
                </li>
                <li>
                    <a href="http://">Beagles Links</a>
                </li>
                <li>
                    <a href="http://">Leash Your Beagle</a>
                </li>
                <li>
                    <a href="http://">House Training</a>
                </li>
            </ul>
        </div>
    </div>
  </div>
  <div class="column card">
    <div class="content">
        <span>{{sample | striphtml}}</span>
    </div>
  </div>
  <div class="column">
    Third column
  </div>
        </div>
 </div>
    </div>
</template>
<style lang="scss" scoped>
.tb-padding {
    padding: 2rem;
}
</style>
<script>
export default {
  /* eslint-disable */

  data() {
    return {
      posts: [],
      errors: [],

    };
  },
  filters: {
    striphtml: function(value) {
      const div = document.createElement("div");
      div.innerHTML = value;
      const text = div.textContent || div.innerText || "";
      return text;
    }
  }
};
</script>




// WEBPACK FOOTER //
// src/components/about-beagles.vue